<template>
  <SearchContainer @reset="resetFilters" @search="search">
    <template slot="default">
      <div class="row">
        <div class="col-12 col-sm-4 mb-3">
          <Input
            type="text"
            :label="$t('sections.ords.search.locationId')"
            :field="query.location_id"
            @input="(e) => onInput('location_id', e)"
          />
        </div>
        <div class="col-12 col-sm-4 mb-3">
          <Input
            type="text"
            :label="$t('sections.ords.search.cpe')"
            :field="query.cpe"
            @input="(e) => onInput('cpe', e)"
          />
        </div>
        <div class="col-12 col-sm-4 mb-3">
          <Input
            type="dropdown"
            :label="$t('sections.ords.search.status')"
            :field="query.cpeStatus"
            :items="$t('sections.ords.search.statusOptions')"
            @input="(e) => onInput('cpeStatus', e)"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <Input
            type="datepicker"
            :label="$t('sections.ords.search.start')"
            :field="query.integrationStart"
            @input="(e) => onInput('integrationStart', e)"
          />
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <Input
            type="datepicker"
            :label="$t('sections.ords.search.end')"
            :field="query.integrationEnd"
            :valid="validInterationEndDate"
            :errorLabel="$t('components.horizontalInput.invalidEndDate')"
            @input="(e) => onInput('integrationEnd', e)"
          />
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <el-button type="primary" @click="search" class="mb-3">
          <font-awesome-icon icon="fa-regular fa-magnifying-glass" class="mr-2" />
          {{ $t("sections.common.search.searchButton") }}
        </el-button>
      </div>
    </template>
  </SearchContainer>
</template>

<script>
import SearchContainer from '@/components/sections/common/SearchContainer.vue';
import Input from '@/components/ui/Input.vue';

export default {
  name: 'ORDsListSearchOptions',
  components: {
    SearchContainer,
    Input,
  },
  data() {
    return {
      query: {
        location_id: '',
        cpe: '',
        cpeStatus: '',
        integrationStart: '',
        integrationEnd: '',
      },
    };
  },
  computed: {
    validInterationEndDate() {
      if (this.query.integrationStart) {
        return (
          !this.query.integrationEnd
          || this.query.integrationEnd > this.query.integrationStart
        );
      }
      return true;
    },
    validSearch() {
      // TODO check required fields
      return true;
    },
  },
  methods: {
    onInput(field, value) {
      this.query[field] = value;
    },
    search() {
      this.$emit('onSearch', this.query);
    },
    resetFilters() {
      this.query = {
        location_id: '',
        cpe: '',
        cpeStatus: '',
        integrationStart: '',
        integrationEnd: '',
      };

      this.$emit('onSearch', this.query);
    },
  },
};
</script>
<style lang="scss" scoped></style>
